var skeletonData = {
  name: 'skeleton',
  data: [{
    barColor: '#F2F2F2',
    titleHeight: "0.24rem"
  }]
};
export default skeletonData;